import { render, staticRenderFns } from "./OppoConfig.vue?vue&type=template&id=176e58b8&scoped=true&"
import script from "./OppoConfig.vue?vue&type=script&lang=js&"
export * from "./OppoConfig.vue?vue&type=script&lang=js&"
import style0 from "./OppoConfig.vue?vue&type=style&index=0&id=176e58b8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176e58b8",
  null
  
)

export default component.exports